import { resultLabel } from "@/i18n";

const tones = {
  FULL_WIN: "win", PARTIAL_WIN: "win", PARTIAL_WIN_THEN_BE: "win",
  MANUAL_PROFIT_CLOSE: "win", LOSS: "loss", MANUAL_LOSS_CLOSE: "loss",
  BREAKEVEN: "be", AMBIGUOUS: "ambiguous", UNVERIFIED: "muted",
  NOT_TRIGGERED: "muted", OPEN: "open", MATCH: "win", MISMATCH: "loss",
};

export const ResultBadge = ({ value, testId }) => (
  <span className={`result-badge ${tones[value] || "muted"}`} data-testid={testId}>
    {resultLabel(value)}
  </span>
);